export const API_BASE_URL = 'https://api.plataformaeco.com';
export const AUTH_TOKEN = 'at_cli';
export const REFRESH_TOKEN = 'rt_cli';
export const USER_INFO = 'ue_cli';
